import { Component, Input, OnChanges } from "@angular/core";
import { DateService } from "@app/services/date.service";
import { IDataDefinition } from "../../models/IReportDefinition";

interface IPageTitlePill {
    label: string;
    icon?: string;
}

@Component({
    selector: "report-title",
    template: require("./report-title.component.html")
})
export class ReportTitleComponent implements OnChanges {
    @Input() title: string;
    @Input() dataDefinition: IDataDefinition;

    pills: IPageTitlePill[] = [];

    constructor(private readonly dateService: DateService) {
    }

    ngOnChanges() {
        if (!this.dataDefinition.Parameters) {
            return;
        }

        if (this.dataDefinition.Parameters.Start) {
            this.pills.push({
                label: this.dateService.formatDateRange(this.dataDefinition.Parameters.Start, this.dataDefinition.Parameters.End),
                icon: "date_range"
            });
        }
    }

    // ---

}
